import * as React from "react";
import {cx} from "emotion";

import "./sc-mailing-unaddressed-copies-quantity-logic.scss";

import {cs}                 from "@Common/react/chain-services";
import {DebounceCache}      from "@Common/react/debounce-cache";
import {NumberInputBinding} from "@Common/react/number-input-binding";
import {Static2}            from "@Common/react/static-2";
import {ErrorHighlighter}   from "@Common/ui-components/light/error-highlighter";
import {scrollIntoView}     from "@Common/ui-components/light/scroll-into-view";

import {getQuantityErrorMessage} from "@Xpresso/routes/customize/steps/common/get-quantity-error-message";

import {ScQuantityLogic} from "../../common/sc-quantity-logic";

export const ScMailingUnaddressedCopiesQuantityLogic = ({initEnrollment, enabled, next: rootNext}) => cs(
    ["logic", ({}, next) => ScQuantityLogic({
        path: ["distribution_options", "mailing", "unaddressed_copies", "quantity"],
        defaultValue: 25,
        initEnrollment, enabled,
        next,
    })],
    ["eh", (_, next) => ErrorHighlighter({next})],
    ["domRef", (_, next) => Static2({next})],
    ["step2Params", ({logic}, next) => rootNext({
        quantity: logic.quantity,
        renderStep2: next,
    })],
    ({logic, step2Params, eh, domRef}) => step2Params.next({
        enrollmentEditor: logic.enrollmentEditor ? {
            ...logic.enrollmentEditor,

            valid: !!step2Params.paperPrice,
            errorsHandling: {
                highlightErrors: () => {
                    eh.start();
                    scrollIntoView(domRef.get());
                },
            },
        } : logic.clearEnrollmentEditor,
        ui: ({showErrors}) => (
            <div className={cx("sc-mailing-unaddressed-copies-quantity-logic-4dk", eh.css)} ref={domRef.set}>
                {cs(
                    ["debounce", (_, next) => DebounceCache({
                        state: logic.state,
                        next,
                    })],
                    ["binding", ({debounce}, next) => NumberInputBinding({
                        state: debounce.state,
                        onFlush: debounce.flush,
                        isValid: v=>v>0,
                        next,
                    })],
                    ({binding}) => (
                        <input {...{
                            disabled: !enabled,
                            ...binding,

                            "xd-qa-type": "text_field",
                            "xd-qa-name": "Additional copies quantity",
                        }}/>
                    ),
                )}

                {enabled && showErrors && !step2Params.paperPrice && (
                    <div className="error">
                        {getQuantityErrorMessage(logic.state.value, {paperPrices: step2Params.paperPrices, method: "shipping"})}
                    </div>
                )}
            </div>
        ),
    }),
);

